export default __webpack_public_path__ + "static/725537f2-fc68-40c2-b3e1-90504a042d38-6e040d17b5030789c31510734a76b056.woff";